import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export const state = () => ({
  products: [],
  items: [],
  item: {},
  index: null,
  loading: false,
  layerId: null
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};